export const MAX_COLUMNS = 12;
export const SCREEN_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'];
export const BREAKPOINTS = {
  xs: 0,
  sm: 544,
  md: 768,
  lg: 992,
  xl: 1200
};